/**
 * @fileoverview Barrel exports for the chapter-entity-detector-v2 agent.
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
} from './schema';

// Flow
export { flow, chapterEntityDetectorV2AgentFlow } from './flow';

// Prompt template
export { prompt } from './prompt';
